module.exports = __webpack_public_path__ + "img/0.b5ecb1ab.svg";